import { IRestaurant, IUser, SelectField, UserRole } from '@localina/core';
import { RestaurantIcon } from '@localina/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetAccount } from '../../api/queries/account';
import { setUserRole } from '../../utils/UserRoleUtils';

export const NO_ACCESS = 'none';

interface IProps {
    user: IUser;
    restaurant: IRestaurant;
    onChange: (user: IUser) => void;
}

export const UserRoleMappingListItem: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    const accountQuery = useGetAccount();

    const mapping = props.user.rolesMapping.find((item) => item.restaurantId === props.restaurant.id);

    const currentRole = mapping && mapping.roles.length > 0 ? mapping.roles[0] : NO_ACCESS;

    const options = availableRoles(
        props.restaurant.id,
        accountQuery.isSuccess ? accountQuery.data.hasFeature : undefined,
    ).map((role) => ({
        value: role ?? NO_ACCESS,
        label: role ? t(`user.roles.${role}`) : t('user.roles.none'),
    }));

    const { street, streetNumber, postalCode, city } = props.restaurant.info;

    return (
        <div className="user-role-item">
            <span className="user-role-item__icon">
                <RestaurantIcon />
            </span>
            <div className="user-role-item__main">
                <span className="user-role-item__name">{props.restaurant.info.name}</span>
                <span className="user-role-item__address">{`${street} ${streetNumber} · ${postalCode} ${city}`}</span>
            </div>
            <div className="user-role-item__role">
                {}
                <SelectField
                    label=""
                    value={currentRole}
                    options={options}
                    SelectProps={{
                        inputProps: {
                            'aria-label': t('user.roles.forRestaurant', { name: props.restaurant.info.name }),
                        },
                    }}
                    onChange={(value) =>
                        props.onChange(
                            setUserRole(
                                props.user,
                                props.restaurant.id,
                                value === NO_ACCESS ? undefined : (value as UserRole),
                            ),
                        )
                    }
                />
            </div>
        </div>
    );
};

export const availableRoles = (
    restaurantId: string,
    hasFeature?: (feature: any, restaurantId: string) => boolean,
): (UserRole | undefined)[] =>
    [undefined, UserRole.ADMIN, UserRole.SERVICE, UserRole.SERVER, UserRole.RECEPTION].filter((role) => {
        if (role === UserRole.RECEPTION) {
            return Boolean(hasFeature?.('reception', restaurantId));
        }
        if (role === UserRole.SERVICE) {
            return Boolean(hasFeature?.('service', restaurantId));
        }
        return true;
    });
